import React from 'react';
import TradingViewStrategyAnalyzer from './TradingViewStrategyAnalyzer';

function App() {
  return (
    <div className="App">
      <TradingViewStrategyAnalyzer />
    </div>
  );
}

export default App;